import * as React from "react";
import { Link } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";

import Copyright from "../../Components/Copyright";
import LoginEspace from "./LoginEspace";
import LoginFinancing from "./LoginFinancing";

import Logo from "../../Images/logo-large.png";
import iconSimulateur from "../../Images/icon_simulateur.png";
import iconRdv from "../../Images/icon_rdv.png";
import iconFinancement from "../../Images/icon_financement.png";
import iconLogin from "../../Images/icon_login.png";

import "./Login.scss";

const Login = () => {
  const [toggleLoginPage, setToggleLoginPage] = React.useState(true);

  const handleToggleLogin = () => {
    setToggleLoginPage((prev) => !prev);
  };

  return (
    <div className="login-page">
      <div className="wrap-logo">
        <img src={Logo} alt="" />
      </div>
      <div className="wrap-login-page">
        <div className="content-form">
          {toggleLoginPage ? <LoginEspace /> : <LoginFinancing />}
        </div>

        <div className="content-form">
          <div className="title-content-form">
            Facilitez vos projets, nous vous accompagnons à chaque moment clé.
          </div>
          <div className="box-links-not-authentified">
            <Link
              to="/prise-de-rendez-vous"
              className="box-rdv-not-authentified box-links-login-page"
            >
              <div className="icon-rdv-not-authentified">
                <img src={iconRdv} alt="" />
              </div>
              <div className="wrap-content-links-arrow">
                <div className="content-links-not-authentified">
                  <div className="title-not-authentified">
                    Je souhaite prendre rendez-vous
                  </div>
                </div>
                <div className="arrow-right-sline">
                  <RiArrowRightSLine />
                </div>
              </div>
            </Link>

            <Link
              to="/simulations"
              className="box-simulateur-not-authentified box-links-login-page"
            >
              <div className="icon-simulateur-not-authentified">
                <img src={iconSimulateur} alt="" />
              </div>
              <div className="wrap-content-links-arrow">
                <div className="content-links-not-authentified">
                  <div className="title-not-authentified">
                    Je souhaite simuler mon projet de financement
                  </div>
                </div>
                <div className="arrow-right-sline">
                  <RiArrowRightSLine />
                </div>
              </div>
            </Link>

            {toggleLoginPage ? (
              <div
                className="box-toggle-login box-links-login-page"
                onClick={handleToggleLogin}
              >
                <div className="icon-simulateur-not-authentified">
                  <img src={iconFinancement} alt="" />
                </div>
                <div className="wrap-content-links-arrow">
                  <div className="content-links-not-authentified">
                    <div className="title-not-authentified">
                      Je souhaite suivre ma demande de financement
                    </div>
                  </div>
                  <div className="arrow-right-sline">
                    <RiArrowRightSLine />
                  </div>
                </div>
              </div>
            ) : (
              <div
                className="box-toggle-login box-links-login-page"
                onClick={handleToggleLogin}
              >
                <div className="icon-simulateur-not-authentified">
                  <img src={iconLogin} alt="" />
                </div>
                <div className="wrap-content-links-arrow">
                  <div className="content-links-not-authentified">
                    <div className="title-not-authentified">
                      Je souhaite me connecter à mon compte
                    </div>
                  </div>
                  <div className="arrow-right-sline">
                    <RiArrowRightSLine />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Copyright />
    </div>
  );
};

export default Login;
